import React, { useState } from "react";
import withJuspay from "@hooks/withJuspay";

const OnlinePaymentHOC = (OnlinePaymentScreen) => {
  return function Wrapper(props) {
    const [initiateResult, setInitiateResult] = useState(() => () => {});
    const [processResult, setProcessResult] = useState(() => () => {});

    const { processPayment } = withJuspay({
      initiateResult,
      processResult,
    });

    return (
      <OnlinePaymentScreen
        {...props}
        processPayment={processPayment}
        setInitiateResult={setInitiateResult}
        setProcessResult={setProcessResult}
      />
    );
  };
};

export default OnlinePaymentHOC;
